module.exports = __webpack_public_path__ + "static/img/conasi_logo_1.32df7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conasi_logo_1.png
// module id = KXGO
// module chunks = 0